import { WriterTypes } from '../../enums/file-writer/writer-types';
import { IFileWriter } from '../../interfaces/file-io/ifile-writer';
import { FileWriterConfigTypes } from '../../types/file-writer-config-types';
import { CsvWriterProps } from '../file-writer/csv-writer-props';
import { SftpConnectorBase } from './sftp-connector-base';

/**
 * Configuration for an SFTPWriter task. Extends SftpConnectorBase with file
 * format settings. writerConfig shape depends on writerType (CSV/XML/JSON).
 * fileName is contained inside writerConfig (from FileWriterBase), not as a
 * direct property.
 */
export class SftpWriterConfig extends SftpConnectorBase implements IFileWriter {
	/**
	 * File format to write. CSV=0, XML=1, JSON=2.
	 * @default WriterTypes.CSV
	 */
	writerType = WriterTypes.CSV;

	/**
	 * Format-specific writer configuration. Use CsvWriterProps for CSV,
	 * XmlWriterProps for XML, JsonWriterProps for JSON. All types inherit
	 * FileWriterBase (fileName, writeMode, lineEnd, exportBehavior, uniqueness).
	 */
	writerConfig: FileWriterConfigTypes = new CsvWriterProps();

	constructor(init?: Partial<SftpWriterConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
